import styled from "styled-components";

export const HowToContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 640px;
`;

export const HowToFrame = styled.iframe<{ $isLoading: boolean }>`
  width: 100%;
  height: 100vh;
  min-height: 640px;
  border: 0;
  visibility: ${({ $isLoading }) => ($isLoading ? "hidden" : "visible")};
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
